import React from 'react';
import { useStrings } from '../i18n';

export default function About() {
  const strings = useStrings();
  return (
    <div className="w-full max-w-5xl mx-auto px-4 md:px-6 py-12 md:py-20 space-y-8 md:space-y-12">
      <h1 className="text-3xl md:text-5xl font-heading text-headingText text-center">{strings.home.about.title}</h1>
      {strings.home.about.paragraphs.map((p, i) => (
        <p key={i} className="text-sm md:text-base text-bodyText leading-relaxed">{p}</p>
      ))}
    </div>
  );
}
